import { render, staticRenderFns } from "./titleBqList.vue?vue&type=template&id=0ce71672&scoped=true"
import script from "./titleBqList.vue?vue&type=script&lang=js"
export * from "./titleBqList.vue?vue&type=script&lang=js"
import style0 from "./titleBqList.vue?vue&type=style&index=0&id=0ce71672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce71672",
  null
  
)

export default component.exports